import { UnitAccountViewModel } from '@ail/customers-api'
import { useMemo } from 'react'
import { useGetAllUnitsQuery } from '../redux/api/customerApi'

export function useUnitsByCustomer(): Record<string, UnitAccountViewModel[]> {
  const { data: allUnits = [] } = useGetAllUnitsQuery()

  return useMemo(
    () =>
      allUnits.reduce<Record<string, UnitAccountViewModel[]>>((acc, { unit }) => {
        if (unit) {
          if (!acc[unit?.customerId]) acc[unit.customerId] = []
          acc[unit.customerId].push(unit)
        }
        return acc
      }, {}),
    [allUnits]
  )
}
